import { useState, useEffect } from 'react';
import PhotoVerify from 'components/Profile/PhotoVerify';
import { Button } from 'components';
import { maxFileSize, validateGhanaCard } from 'components/misc/functions';
import { useDispatch } from 'react-redux';
import { show } from 'providers/toastSlice';
import { fetchRequests } from 'https/requests';
import { STAGING_AUTH } from '../../config/env';

function PhoneVerify({ phoneNumber, nextStep }) {

    const dispatch = useDispatch();

    const [cardNumber, setCardNumber] = useState('');
    const [frontPhoto, setFrontPhoto] = useState('');
    const [backPhoto, setBackPhoto] = useState('');
    const [selfie, setSelfie] = useState('');
    const [isMobile, setIsMobile] = useState(false);
    const [processing, setProcessing] = useState(false);

    const handleSubmit = async(event) => {
        event.preventDefault();
        setProcessing(true);
        
        let url = `${STAGING_AUTH}/verify-account`;
        let headers = {
            'Content-Type': 'multipart/form-data'
        }

        if(!validateGhanaCard(cardNumber)){
            dispatch(show({
                state : true,
                message : "Invalid GhanaCard Number, must be in the format GHA-123456789-0",
                type : "error"
            }))
            setProcessing(false);
            return;
        }

        if(selfie.size > maxFileSize){
            dispatch(show({
                state : true,
                message : "Selfie file size is too large. Maximum file size is 1MB",
                type : "error"
            }))
            setProcessing(false);
            return;
        }

        const formData = new FormData();
        formData.append('phoneNumber', phoneNumber);
        formData.append('cardNumber', cardNumber);
        formData.append('ghanaCardFrontPhoto', frontPhoto);
        formData.append('ghanaCardBackPhoto', backPhoto);
        formData.append('selfie', selfie);

        let res = await fetchRequests(url, "POST", headers, {}, formData);
        setProcessing(false);

        if(res?.err){
			dispatch(show({
				state : true,
				message : `${res?.err}`,
				type : "error"
			}))
			return;
		}

        // if successful, show success message
        nextStep();

    };

    useEffect(() => {
        function isMobile() {
            const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            return regex.test(navigator.userAgent);
        }
    
        if (isMobile()) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }

        isMobile();
    }, [])
    
    return (
        <>
        {isMobile ? (
        <div>
            <div className='md:hidden mb-6'>
                {/* insert image here (if needed) */}
                <h2 className='text-5xl font-semibold tracking-tight text-balance text-gray-900 dark:text-slate-200 sm:text-7xl'>
                    Let's verify your account
                </h2>
                <p className='mt-8 text-sm font-medium text-pretty text-gray-400 dark:text-slate-200 sm:text-xl/6'>
                    Please submit the following identification materials to verify your account.
                </p>
            </div>

            <form onSubmit={handleSubmit} className='grid grid-cols-1 md:grid-cols-2 gap-4 w-full space-y-6 pb-8'>
                <div className="col-span-2">
                    <label htmlFor="ghanaCard" className="form-label">
                        GhanaCard Number
                    </label>
                    <input
                        type="text"
                        name="ghanaCard"
                        id="ghanaCard"
                        className="form-input disabled:opacity-75 disabled:bg-gray-200 placeholder:text-gray-700 disabled:cursor-not-allowed"
                        placeholder="GhanaCard Number"
                        value={cardNumber}
                        onChange={(e) => setCardNumber(e.target.value)}
                    />
                </div>

                {/* Front photo */}
                <div className="col-span-2">
                    <PhotoVerify 
                        label={"Front photo of GhanaCard"}
                        name={"front-photo"}
                        value={frontPhoto}
                        setValue={setFrontPhoto}
                    />
                </div>
                {/* Front photo */}

                {/* Back photo */}
                <div className="col-span-2">
                    <PhotoVerify 
                        label={"Back photo of GhanaCard"}
                        name={"back-photo"}
                        value={backPhoto}
                        setValue={setBackPhoto}
                    />
                </div>
                {/* Back photo */}

                {/* Selfie photo */}
                <div className="col-span-2">
                    <PhotoVerify 
                        label={"Selfie of you"}
                        name={"selfie-photo"}
                        value={selfie}
                        setValue={setSelfie}
                    />
                </div>
                {/* Selfie photo */}

                <div className='col-span-2'>
                    <Button 
                        btnText={"Verify"}
                        btnType={"submit"}
                        btnClasses={"rounded-md bg-gold-500 px-3.5 py-2.5 text-sm font-semibold text-white w-full shadow-sm hover:bg-gold-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-500"}
                        processing={processing}
                        disabled={cardNumber !== "" && frontPhoto !== "" && backPhoto !== "" && selfie !== "" ? false : true}
                    />
                </div>
            </form>
        </div>
        ) : (
            <div className='flex flex-col items-center justify-center h-full'>
                <h2 className='text-5xl md:text-center font-semibold tracking-tight text-balance text-gray-900 dark:text-slate-200 sm:text-7xl'>
                    Mobile Device Required
                </h2>
                <p className='mt-8 text-sm font-medium text-pretty text-gray-400 dark:text-slate-200 sm:text-xl/6'>
                    Please use a mobile device to complete this verification process.
                </p>
                <p className='mt-4 text-sm font-medium text-pretty text-gray-400 dark:text-slate-200 sm:text-xl/6'>
                    Thank you for your understanding!
                </p>
            </div>
        )}
        </>
    )
}

export default PhoneVerify